import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  DEPARTMENT,
  DEPARTMENT_ALL,
  DEPARTMENT_CREATE,
  DEPARTMENT_LABELS,
  DEPARTMENT_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const departmentsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const departmentSelector = createSelector(departmentsSelector, data => data[DEPARTMENT])

export const departmentAllSelector = createSelector(departmentsSelector, data => data[DEPARTMENT_ALL])

export const departmentListSelector = createSelector(departmentsSelector, data => data[DEPARTMENT_LIST])

export const departmentCreateSelector = createSelector(departmentsSelector, data => data[DEPARTMENT_CREATE])

export const departmentLabelsSelector = createSelector(departmentsSelector, data => data[DEPARTMENT_LABELS])
